module.exports = __webpack_public_path__ + "img/action-RC.02420908.svg";